import { GetServerSideProps } from 'next';

import AgentProfilePage from '../../components/agent-profile/agent-profile-page';
// Server only - kept in its own module so the client bundle does not pull in
// the Node dependencies behind getServerSideProps
import { getAgentProfilePageServerSideProps } from '../../components/agent-profile/get-agent-profile-page-server-side-props';

export default AgentProfilePage;

export const getServerSideProps: GetServerSideProps = async (context) =>
  getAgentProfilePageServerSideProps(context);
